import React from 'react';

import PressesAndShears from './Protocols/PressesAndShears';
import Ladders from './Protocols/Ladders';
import Shelves from './Protocols/ShelvingSystems';
import IndustrialVehicles from './Protocols/IndustrialVehicles';
import WorkingPlatform from "./Protocols/WorkingPlatform";
import SlidingDoors from './Protocols/SlidingDoors';
import SectionalDoors from "./Protocols/SectionalDoors";
import Grid from "@material-ui/core/Grid/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import i18n from "../../i18n";
import ElectricalSafety from "./Protocols/ElectricalSafety";
import ElectricalSystems from "./Protocols/ElectricalSystems";
import Slings from "./Protocols/Slings";
import PneumaticalSlidingDoors from "./Protocols/PneumaticalSlidingDoors";
import Cranes from './Protocols/Cranes';
import PowerOperatedRollingDoors from './Protocols/PowerOperatedRollingDoors';
import Presses from './Protocols/Presses';
import FireDoors from "./Protocols/FireDoors";

class ProtocolsFormFields extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
        };
    }

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            appointment,
            structure,
            uploadConfig,
            isSubmitting,
        } = this.props;

        return (
            <form
                method="POST"
                url={formUrl}
                onSubmit={handleSubmit}
            >
                <input type="hidden" name="customer_id" value={values.customer_id} onChange={handleChange}/>
                <input type="hidden" name="customer_name" value={values.customer_name} onChange={handleChange}/>
                <input type="hidden" name="appointment_id" value={values.appointment_id} onChange={handleChange}/>
                <input type="hidden" name="appointment_name" value={values.appointment_name} onChange={handleChange}/>
                <input type="hidden" name="structure_id" value={values.structure_id} onChange={handleChange}/>
                <input type="hidden" name="structure_name" value={values.structure_name} onChange={handleChange}/>
                <Grid container spacing={24}>
                    <Grid item xs={1}></Grid>
                    <Grid item xs={10}>
                        <Grid container spacing={24}>
                            <Grid item xs={12}>
                                <FormLabel>{structure.name}</FormLabel>
                            </Grid>
                            <Grid item xs={12}>
                                <FormLabel>{structure.legal_regulation}</FormLabel>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider/>
                            </Grid>

                            <Grid item xs={12}>
                                <FormLabel>Auftraggeber: &nbsp; {customer.customer_name}</FormLabel>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider/>
                            </Grid>

                            <Grid item xs={12}>
                                <Grid container spacing={24} alignItems="center">
                                    {
                                        structure.id === 1 &&
                                        <Presses {...this.props}/>
                                    }
                                    {
                                        structure.id === 2 &&
                                        <Ladders {...this.props}/>
                                    }
                                    {
                                        structure.id === 3 &&
                                        <Shelves {...this.props}/>
                                    }
                                    {
                                        structure.id === 4 &&
                                        <IndustrialVehicles {...this.props}/>
                                    }
                                    {
                                        structure.id === 5 &&
                                        <PneumaticalSlidingDoors {...this.props}/>
                                    }
                                    {
                                        structure.id === 6 &&
                                        <WorkingPlatform {...this.props}/>
                                    }
                                    {
                                        structure.id === 7 &&
                                        <SlidingDoors {...this.props}/>
                                    }
                                    {
                                        structure.id === 8 &&
                                        <SectionalDoors {...this.props}/>
                                    }
                                    {
                                        structure.id === 9 &&
                                        <Slings {...this.props}/>
                                    }
                                    {
                                        structure.id === 10 &&
                                        <ElectricalSafety {...this.props}/>
                                    }
                                    {
                                        structure.id === 11 &&
                                        <ElectricalSystems {...this.props}/>
                                    }
                                    {
                                        structure.id === 12 &&
                                        <PowerOperatedRollingDoors {...this.props}/>
                                    }
                                    {
                                        structure.id === 13 &&
                                        <Cranes {...this.props}/>
                                    }
                                    {
                                        structure.id === 14 &&
                                        <FireDoors {...this.props}/>
                                    }

                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <Divider/>
                            </Grid>
                        </Grid>

                        <Grid container spacing={24} justify="space-between" alignItems="center"
                              style={{paddingTop: 8}}>
                            <Grid item>
                                <Button size="small"
                                        variant="contained"
                                        color="primary"
                                        type="submit"
                                        disabled={isSubmitting}
                                >
                                    <Icon fontSize="small">save</Icon>
                                    &nbsp;
                                    {i18n.get('persons.save')}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={1}></Grid>
            </form>
        )
    }
}

export default ProtocolsFormFields



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/ProtocolsFormFields.js